module.exports = __webpack_public_path__ + "static/media/thumbnail-dummy.d564ee9c.jpg";